module.exports = __webpack_public_path__ + "img/us_3.2157276f.png";